module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/airstrike.80fffcfe.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/airstrike.png
// module id = 3698
// module chunks = 11